import getAndValidatePeriod from 'utils/pivot/plan/getAndValidateDuration'
import descSort from 'utils/descSort'

type GetCorrespondingPolicyParams = {
  plan: Plan
  mainPeriod?: number | string
  additionalPeriods?: number[]
  policyIndex?: string
}

function getCorrespondingPolicy({
  plan,
  mainPeriod = undefined,
  additionalPeriods = undefined,
  policyIndex = '1'
}: GetCorrespondingPolicyParams) {
  let planDuration: Durations | undefined = mainPeriod && plan.durations[mainPeriod]

  if (!planDuration && additionalPeriods)
    planDuration = additionalPeriods
      .sort(descSort)
      .map(p => plan.durations[p])
      .filter(Boolean)[0]

  if (!planDuration) planDuration = getAndValidatePeriod(plan, mainPeriod)

  return (
    planDuration &&
    (planDuration[policyIndex] ||
      Object.keys(planDuration)
        .map(k => +k)
        .sort(descSort)
        .map(k => planDuration[k])[0])
  )
}

export default getCorrespondingPolicy
